import {state} from './state';
import {getters} from './getters';
import {mutations} from './mutations';
import {actions} from './actions';
// import { I18nService } from '../../services/i18n';

export default {
  state,
  getters,
  mutations,
  actions
};


// I18nService.getLanguageDict('en').then(res => {
//   console.log(res.i18nDict);

//   const engDict = JSON.parse(res.i18nDict);
//   console.log(engDict);
// });
// I18nService.getLanguageDict('de').then(res => {
//   console.log(res.i18nDict);

//   const deDict = JSON.parse(res.i18nDict);
//   console.log(deDict);
// });